export function createLogger(name: string) {
  return {
    error: (method: string, error: unknown) => {
      console.error(`[${name}:${method}]`, error);
    },
  };
}
